import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const DraftContainerLink = styled(Link)`
    position: relative;
    display: block;
    padding: 1.2rem;
    background-color: ${tokens.background.paperElevation2};
    transition: background-color 0.2s ease-in-out;
    border-bottom: 0.1rem solid ${tokens.border.default};
    /* undo link style */
    text-decoration: none;

    &:hover {
        background-color: ${tokens.action.hover};
    }
    &:focus-visible {
        outline: 0.2rem solid ${tokens.text.link};
        outline-offset: -0.2rem;
        border-radius: 0.8rem;
    }
`;

export const DraftContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;

export const TopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1.6rem;
`;

export const HeadingContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    min-width: 0;
`;

export const IssueTitle = styled.span`
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2rem;
    color: ${tokens.text.primary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ExternalLinkIcon = styled(FontAwesomeIcon)`
    width: 1.4rem;
    height: 1.4rem;
    opacity: 0;
    transition: all 0.2s ease;
    color: ${tokens.text.primary};

    ${DraftContainerLink}:hover & {
        opacity: 1;
    }
`;

export const FaultLocation = styled.div`
    font-size: 1.4rem;
    font-weight: 300;
    line-height: 2rem;
    color: ${tokens.text.primary};
`;

export const LozengesRow = styled.div`
    display: flex;
    align-items: center;
    gap: 1.6rem;
`;

export const Lozenges = styled.div`
    display: flex;
    gap: 0.8rem;
    flex-wrap: wrap;
`;

export const CreatedDate = styled.div`
    font-size: 1.4rem;
    font-weight: 300;
    line-height: 2rem;
    color: ${tokens.text.secondary};
    white-space: nowrap;
`;
